import { PREVIEWABLE_MIMETYPES } from "./index";

const EXTENSION_TO_MIME = new Map([
  ["mp4", "video/mp4"], ["webm", "video/webm"], ["mov", "video/quicktime"],
  ["mpeg", "video/mpeg"], ["avi", "video/x-msvideo"],
  ["jpg", "image/jpeg"], ["jpeg", "image/jpeg"], ["png", "image/png"],
  ["gif", "image/gif"], ["webp", "image/webp"], ["svg", "image/svg+xml"],
  ["bmp", "image/bmp"], ["tiff", "image/tiff"], ["tif", "image/tiff"],
  ["mp3", "audio/mpeg"], ["wav", "audio/wav"], ["ogg", "audio/ogg"],
  ["pdf", "application/pdf"], ["json", "application/json"],
  ["csv", "text/csv"], ["txt", "text/plain"], ["xml", "text/xml"],
  ["html", "text/html"], ["htm", "text/html"],
]);

const lookupMime = (filePath: string) => {
  const ext = (filePath || "").split(".").pop()?.toLowerCase() || "";
  return EXTENSION_TO_MIME.get(ext) || "";
};

export const assetIsPreviewable = (
  dataAsset: any,
  previewableMimetypes = PREVIEWABLE_MIMETYPES
) => {
  const assetPath = dataAsset?.path || dataAsset?.name || "";
  const assetType = lookupMime(assetPath);
  return {
    assetType,
    canPreview: !!assetType && previewableMimetypes.has(assetType),
  };
};
